import type { LucideIcon } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  testId,
}: {
  icon: LucideIcon
  title: string
  description?: string
  action?: { label: string; onClick: () => void }
  testId?: string
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid={testId}>
      <Icon
        size={48}
        strokeWidth={1}
        className="mb-4 text-[var(--green)] opacity-40"
      />
      <p className="text-base text-[var(--ink)]">{title}</p>
      {description && (
        <p className="mt-1 max-w-[260px] text-sm text-[var(--ink-3)]">
          {description}
        </p>
      )}
      {action && (
        <Button
          onClick={action.onClick}
          className="mt-4 cursor-pointer rounded-[4px] bg-[var(--green)] px-4 py-2 text-sm uppercase tracking-[0.1em] text-white transition-opacity hover:bg-[var(--green-hover)]"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
